module.exports = __webpack_public_path__ + "img/phone-screen-thai.62a0f4b8.png";